module.exports = __webpack_public_path__ + "img/CB0000_rabbit.d6b5d48c.png";